import { createQueryKeys } from '@lukemorales/query-key-factory';

import {
  getJobOffersToAnalysis,
  getResumeToOfferAnalysis,
} from '@/services/resumeToOfferAnalysis';

export const resumeToOfferAnalysis = createQueryKeys('resumeToOfferAnalysis', {
  detail: (id: number) => ({
    queryKey: [id],
    queryFn: () => getResumeToOfferAnalysis(id),
  }),
  jobOffersToAnalysis: (resumeId: number) => ({
    queryFn: () => getJobOffersToAnalysis({ resumeId }),
    queryKey: [resumeId],
  }),
});
